import React, { useEffect, useRef, useState } from 'react';
import { BookOpenIcon, FileTextIcon, GiftIcon, LockIcon, ShieldCheckIcon, StarIcon, TimerIcon, ZapIcon } from 'lucide-react';
const PRODUCT_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/pUE6RWfrNFwzzniQzmkd2B/hf_20260722_134845_db58c9d9-d8d0-4db8-88be-7369cc46d11d.png';
const launchTestimonials = [{
  quote: 'Pasé de tardar 4 horas por clienta a 90 minutos. Hoy atiendo el triple y termino el día sin las manos destrozadas.',
  name: 'Mariana G.',
  role: 'Estilista'
}, {
  quote: 'Dejé de cobrar “a ojo”. Con la calculadora subí mis precios sin miedo y ninguna clienta se fue.',
  name: 'Carla R.',
  role: 'Instaladora'
}, {
  quote: 'El mapa de divisiones me cambió el trabajo: instalaciones parejas, sin huecos y sin que se vean los puntos de unión.',
  name: 'Valentina S.',
  role: 'Estilista'
}];
export function Hero() {
  const ctaAnchorRef = useRef<HTMLDivElement>(null);
  const [heroCtaPassed, setHeroCtaPassed] = useState(false);
  const [pricingVisible, setPricingVisible] = useState(false);
  const showStickyCta = heroCtaPassed && !pricingVisible;
  useEffect(() => {
    const ctaAnchor = ctaAnchorRef.current;
    const pricingSection = document.getElementById('pricing');
    if (!ctaAnchor || !pricingSection) return;
    const heroObserver = new IntersectionObserver(([entry]) => {
      setHeroCtaPassed(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0.25
    });
    const pricingObserver = new IntersectionObserver(([entry]) => {
      setPricingVisible(entry.isIntersecting);
    }, {
      rootMargin: '0px 0px -96px 0px',
      threshold: 0.05
    });
    heroObserver.observe(ctaAnchor);
    pricingObserver.observe(pricingSection);
    return () => {
      heroObserver.disconnect();
      pricingObserver.disconnect();
    };
  }, []);
  return <>
      <header className="w-full bg-cream px-5 pt-5 sm:px-7" data-id="element-54" data-mp="2hjyp77sp72oq">
        <div className="mx-auto flex max-w-6xl items-center justify-between border-b border-brand-100 pb-4" data-id="element-55" data-mp="2ll0g91cgo8fm">
          <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-brand-900 sm:text-xs" data-id="element-56" data-mp="s333va8e4ivy">
            MEGAPACK EXTENSIONES™
          </p>
          <span className="hidden text-[10px] font-semibold uppercase tracking-[0.16em] text-brand-600 sm:block" data-id="element-57" data-mp="n9i2d87l96s0">
            Técnica profesional en español
          </span>
        </div>
      </header>

      <main data-id="element-58" data-mp="dbastafmpr01">
        <section className="w-full bg-cream px-5 pb-14 pt-8 sm:px-7 md:pb-20 md:pt-12" data-id="element-59" data-mp="1b0nkju104b5h">
          <div className="mx-auto max-w-3xl" data-id="element-60" data-mp="161t2iuauyqmf">
            <div className="relative z-10 text-center lg:py-8" data-id="element-61" data-mp="16345wt0e5wd0">
              <div className="inline-flex items-center gap-2 rounded-full border border-brand-100 bg-white px-3 py-2 text-[10px] font-bold uppercase tracking-[0.13em] text-brand-700 sm:text-[11px]" data-id="element-62" data-mp="112g5xhu6q56n">
                <span aria-hidden="true" data-id="element-63" data-mp="3lsoyezdi9t7k">🔶</span>
                MEGAPACK EXTENSIONES™ — Lo eligen cientos de estilistas
              </div>

              <h1 className="mt-5 max-w-2xl text-[2.65rem] font-semibold tracking-tight text-brand-900 sm:text-6xl lg:text-[4.3rem]" data-id="element-64" data-mp="3hpsdv34enn0z">
                Instala una cabeza completa de extensiones en 90 minutos.
                <span className="text-brand-600" data-id="element-65" data-mp="21b63txn6x0mn"> Sin dañar el pelo. Sin que se note.</span>
              </h1>

              <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-brand-700 sm:text-base lg:mx-0" data-id="element-66" data-mp="267whyfffpm5f">
                Sistema completo para instalar extensiones de pelo — divisiones invisibles, micro-inserción veloz y finalizado de élite. Todo el sistema, paso a paso.
              </p>

              <div className="mt-7 flex flex-wrap justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-brand-800" data-id="element-67" data-mp="2l102mvobog0d">
                <span className="flex items-center gap-1.5" data-id="element-68" data-mp="2tzljmme5bmz1"><BookOpenIcon className="h-4 w-4 text-accent" data-id="element-69" data-mp="2tyadwh15455a" />6 Tomos</span>
                <span className="flex items-center gap-1.5" data-id="element-70" data-mp="un98lk4twddk"><GiftIcon className="h-4 w-4 text-accent" data-id="element-71" data-mp="uoaivme0svu8" />5 Bonos</span>
                <span className="flex items-center gap-1.5" data-id="element-72" data-mp="zmc34an6n17a"><FileTextIcon className="h-4 w-4 text-accent" data-id="element-73" data-mp="zndpvcdk9c4u" />300+ páginas</span>
                <span className="flex items-center gap-1.5" data-id="element-74" data-mp="49jem9ab6vo8"><TimerIcon className="h-4 w-4 text-accent" data-id="element-75" data-mp="3vi6wugd962rk" />Instalación en 90 min</span>
                <span className="flex items-center gap-1.5" data-id="element-76" data-mp="e9a7y7n4v4mq">💇‍♀️ Nanoring &amp; Keratina</span>
              </div>

              <div className="relative mx-auto mt-8 w-full max-w-xl overflow-hidden rounded-2xl bg-brand-50 shadow-lg" data-id="element-77" data-mp="99xirg8shlgz">
                <img src={PRODUCT_IMAGE_URL} alt="Los seis tomos de Megapack Extensiones junto a una guía visual de divisiones invisibles" className="block aspect-square w-full object-contain" data-id="element-78" data-mp="3hr2663rv4ktd" />
              </div>

              <div ref={ctaAnchorRef} className="mx-auto mt-8 w-full max-w-xl" data-id="element-79" data-mp="3rhn03dwld15y">
                <a href="#pricing" className="flex w-full items-center justify-center rounded-full bg-brand-600 px-6 py-4 text-center text-xs font-bold uppercase tracking-[0.1em] text-white shadow-lg transition-colors hover:bg-brand-700" data-id="element-80" data-mp="3moc11yy0tool">
                  QUIERO EL MEGAPACK AHORA
                </a>
              </div>

              <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-2 text-[10px] font-medium text-brand-700" data-id="element-81" data-mp="19hcg053nbpa3">
                <span className="flex items-center gap-1" data-id="element-82" data-mp="1eb6zp8j94496"><LockIcon className="h-3.5 w-3.5" data-id="element-83" data-mp="zl96ufadmqdn" />Pago seguro</span>
                <span className="flex items-center gap-1" data-id="element-84" data-mp="14jkgaowreyvc"><ZapIcon className="h-3.5 w-3.5" data-id="element-85" data-mp="14kcapwemeqk1" />Acceso inmediato</span>
                <span className="flex items-center gap-1" data-id="element-86" data-mp="1s8n7andaa42i"><ShieldCheckIcon className="h-3.5 w-3.5" data-id="element-87" data-mp="1s9ojww9y6ymc" />Garantía de 7 días</span>
                <span data-id="element-88" data-mp="1x6x22wv3j2nl">💯 100% PDF</span>
              </div>
            </div>
          </div>
        </section>

        <section className="border-y border-brand-100 bg-white px-5 py-6 sm:px-7" aria-label="Prueba social" data-id="element-89" data-mp="1j7xbvkrxqfpb">
          <div className="mx-auto grid max-w-6xl grid-cols-2 gap-y-5 text-center md:grid-cols-4" data-id="element-90" data-mp="1n88wwyo7mi1b">
            {[['+500', 'estilistas'], ['6 Tomos + 5 Bonos', 'sistema completo'], ['4.9/5', 'valoración'], ['🌎', 'todo el mundo hispanohablante']].map(([value, label]) => <div key={label} className="border-brand-100 px-3 even:border-l md:border-l" data-id="element-91" data-mp="2ehtxgbhe3q6q">
                <p className="text-xs font-bold text-brand-900 sm:text-sm" data-id="element-92" data-mp="29hxu8egio2s8">{value}</p>
                <p className="mt-1 text-[9px] font-semibold uppercase tracking-[0.13em] text-brand-600" data-id="element-93" data-mp="24rhg0s4vgd4t">{label}</p>
              </div>)}
          </div>
        </section>

        <section className="bg-white px-5 py-16 sm:px-7 md:py-24" data-id="element-94" data-mp="1zqlcifofmszx">
          <div className="mx-auto max-w-6xl" data-id="element-95" data-mp="1vrubvykrct82">
            <div className="mb-10 text-center" data-id="element-96" data-mp="1qrzk7st5rzly">
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-brand-600" data-id="element-97" data-mp="1qr6m1g89miff">Testimonios de lanzamiento</p>
              <h2 className="mt-3 text-4xl font-semibold text-brand-900 md:text-5xl" data-id="element-98" data-mp="1lt526t30mf2w">Lo que cambia cuando dejás de improvisar</h2>
            </div>
            <div className="grid gap-4 md:grid-cols-3" data-id="element-99" data-mp="3g7ftr9azvncd">
              {launchTestimonials.map(testimonial => <article key={testimonial.name} className="rounded-2xl border border-brand-100 bg-cream p-6" data-id="element-100" data-mp="3b82xjxy8h3x4">
                  <div className="flex gap-0.5 text-accent" aria-label="5 de 5 estrellas" data-id="element-101" data-mp="3jpn0scuaetv8">
                    {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-102" data-mp="3np47f9lg9x1z" />)}
                  </div>
                  <blockquote className="mt-4 text-sm leading-relaxed text-brand-800" data-id="element-103" data-mp="3shx9fppjarad">“{testimonial.quote}”</blockquote>
                  <footer className="mt-5 border-t border-brand-100 pt-4" data-id="element-104" data-mp="1coyw0dxpqyf">
                    <p className="text-sm font-bold text-brand-900" data-id="element-105" data-mp="30rsit9b6l80p">{testimonial.name}</p>
                    <p className="mt-0.5 text-[10px] uppercase tracking-[0.1em] text-brand-600" data-id="element-106" data-mp="34s2y5ckv5as8">{testimonial.role}</p>
                  </footer>
                </article>)}
            </div>
            <p className="mt-5 text-center text-xs text-brand-600" data-id="element-107" data-mp="3eqjt0kmxa9jk">Testimonios de lanzamiento. Se reemplazarán por opiniones verificadas de compradoras.</p>
          </div>
        </section>
      </main>

      <div className={`pointer-events-none fixed inset-x-0 bottom-0 z-50 px-4 pb-[calc(1rem+env(safe-area-inset-bottom))] pt-3 transition-[opacity,transform] duration-300 ${showStickyCta ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`} aria-hidden={!showStickyCta} data-id="element-108" data-mp="ty87sbb2eea8">
        <a href="#pricing" tabIndex={showStickyCta ? 0 : -1} className="pointer-events-auto mx-auto flex w-full max-w-md items-center justify-center rounded-full bg-brand-600 px-5 py-4 text-center text-xs font-bold uppercase tracking-[0.08em] text-white shadow-xl transition-colors hover:bg-brand-700" data-id="element-109" data-mp="1otn51iccubq8">
          QUIERO EL MEGAPACK AHORA
        </a>
      </div>
    </>;
}